import {IUser, TUserShipmentData} from "../../models/IUser";

export enum EUserStatus {
    IDLE,
    LOADING,
    SUCCESS,
    ERROR,
    ERROR_OFFER
}

export interface TUserState {
    status: EUserStatus;
    isAuth: boolean;
    user: IUser;
    shipment: TUserShipmentData[];
    notifications: TNotification[];
}

export type TNotification = {
    id: number
    name: string
    userId?: string
    type: "message" | "request" | "payment" | "order" | "price" | "user"
}
